const CloseIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div onClick={onClick} className="cursor-pointer">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.3086 15.9414C17.5195 16.1758 17.625 16.4453 17.625 16.75C17.625 17.0547 17.5195 17.3242 17.3086 17.5586C17.0742 17.7695 16.8047 17.875 16.5 17.875C16.1953 17.875 15.9258 17.7695 15.6914 17.5586L12 13.832L8.30859 17.5586C8.07422 17.7695 7.80469 17.875 7.5 17.875C7.19531 17.875 6.92578 17.7695 6.69141 17.5586C6.48047 17.3242 6.375 17.0547 6.375 16.75C6.375 16.4453 6.48047 16.1758 6.69141 15.9414L10.418 12.25L6.69141 8.55859C6.48047 8.32422 6.375 8.05469 6.375 7.75C6.375 7.44531 6.48047 7.17578 6.69141 6.94141C6.92578 6.73047 7.19531 6.625 7.5 6.625C7.80469 6.625 8.07422 6.73047 8.30859 6.94141L12 10.668L15.6914 6.94141C15.9258 6.73047 16.1953 6.625 16.5 6.625C16.8047 6.625 17.0742 6.73047 17.3086 6.94141C17.5195 7.17578 17.625 7.44531 17.625 7.75C17.625 8.05469 17.5195 8.32422 17.3086 8.55859L13.582 12.25L17.3086 15.9414Z"
          fill="#3A3D50"
        />
      </svg>
    </div>
  );
};

export default CloseIcon;
